module.exports = __webpack_public_path__ + "img/1.fd494b38.png";